var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{attrs:{"height":"30px"}},[_c('div',{staticClass:"container"},[_vm._v("Copyright © 2015-2025 LaClub积分商城 All Rights Reserved")])])}
var staticRenderFns = []

export { render, staticRenderFns }